<template>
  <div>
    <el-tabs type="border-card" class="maintab" style="overflow: auto">
      <el-tab-pane>
				<span slot="label"><i class="el-icon-bangzhu"></i> 发票类型</span>
        <div class="configTab">
          <div class="configTable">
            <el-table
							:data="receiptTypeList"
							ref="supClassTable"
							height="700"
							border
							style="width: 100%"
							v-loading="receiptTypeLoading"
							element-loading-text="拼命加载中"
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(255, 255, 255, 0.8)">
              <div slot="empty">
                <el-empty description="暂无数据"></el-empty>
              </div>
							<el-table-column prop="id" label="类型ID" width="90">
							</el-table-column>
							<el-table-column prop="receiptTypeName" label="类型名称" width="200">
								<template slot-scope="scope">
									<el-input size="mini" v-model="scope.row.receiptTypeName"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="200">
								<template slot-scope="scope">
									<el-tag size="mini" type="warning">{{
										scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
									}}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="操作" min-width="140">
								<template slot-scope="scope">
									<el-button
										type="text"
										size="mini"
										@click="modifyReceiptType(scope.row)"><i class="el-icon-refresh"></i>&nbsp;更新</el-button>
                  <el-button type="text" @click="deleteReceiptType(scope.row)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
								</template>
							</el-table-column>
						</el-table>
          </div>
          <div class="configAdd">
            <h2>添加发票类型</h2>
            <add-receipt-type ref="AddReceiptType" :flush="getReceiptTypeList" />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getReceiptTypeMixins } from '@/mixins/receipt/receiptTypeMixins';
import AddReceiptType from './components/AddReceiptType.vue';
import { modifyType, deleteType } from '@/api/receiptType'
export default {
  name: 'ArgsManage',
  mixins: [getReceiptTypeMixins],
  components: {
    AddReceiptType,
  },
  data() {
    return {
    }
  },
  mounted() {},
  methods: {
    async modifyReceiptType(row) {
      const conf = await this.$confirm('将要更新发票类型，请确定是否继续？', '提示', { type: 'warning' }).catch(err => err)
      if (conf === 'confirm') {
        const { data: res } = await modifyType(row).catch(err => err)
        if (res) {
          this.getReceiptTypeList()
          this.$message.success('更新成功')
        }
      } else {
        this.$message.info('操作已取消')
      }
    },
    async deleteReceiptType(row) {
      const conf = await this.$confirm('将要删除该发票类型，请确定是否继续？', '提示', { type: 'warning' }).catch(err => err)
      if (conf === 'confirm') {
        const { data: res } = await deleteType(row.id).catch(err => err)
        if (res) {
          this.getReceiptTypeList()
          this.$message.success('删除成功')
        }
      } else {
        this.$message.info('操作已取消')
      }
    }
  },
}
</script>
<style scoped lang="less">
.configTab{
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  gap: 60px;
  justify-content: space-between;
  .configTable{
    width: 50%;
    height: 100%;
  }
  .configAdd{
    width: 50%;
    height: 100%;
  }
}
</style>
